import React, { useState, useEffect } from 'react';
import '../agenda.css'
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faChevronLeft, faExclamationTriangle, faCheckDouble, faUserPlus } from '@fortawesome/free-solid-svg-icons';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { useAuthServices } from '../../../services/useFetch';

export const RegistraCita = ({ executeConsulta, setExecuteConsulta, profesionalSeleccionado }) => {

    const { requestPost } = useAuthServices();

    const getColombiaDate = () => {
        return new Date(new Date().toLocaleString("en-US", { timeZone: "America/Bogota" }));
    };

    const formatDate = (date) => {
        if (!date) return '';
        return date.toLocaleDateString('es-CO', {
            timeZone: 'America/Bogota',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        });
    };

    const [modalError, setModalError] = useState(false);
    const [modalSuccess, setModalSuccess] = useState(false);
    const [modalOccupied, setModalOccupied] = useState(false);
    const [modalNuevoCliente, setModalNuevoCliente] = useState(false);
    const [msgError, setMsgError] = useState(false);

    const [manualDate, setManualDate] = useState(getColombiaDate());
    const [manualTime, setManualTime] = useState('');
    const [availabilityInterval, setAvailabilityInterval] = useState('60min');
    const [horariosDisponibilidad, setHorariosDisponibilidad] = useState([]);
    const [clientes, setClientes] = useState([]);

    const [formStateValue, setformStateValue] = useState({
        noDocumento: '',
        nombres: '',
        apellidos: '',
        correo: '',
        correoConfirma: '',
        telefono: '',
        observaciones: ''
    });

    const [formState, setformState] = useState({
        noDocumentoRef: false,
        nombresRef: false,
        apellidosRef: false,
        correoRef: false,
        correoConfirmaRef: false,
        telefonoRef: false,
    });

    const [classAnimateFlujo, setClassAnimateFlujo] = useState('carrusel-p1');

    const {
        noDocumento,
        nombres,
        apellidos,
        correo,
        correoConfirma,
        telefono,
        observaciones } = formStateValue;

    const {
        noDocumentoRef,
        nombresRef,
        apellidosRef,
        correoRef,
        correoConfirmaRef,
        telefonoRef } = formState;

    useEffect(() => {
        obtieneAgendaDelDiaService();
        obtieneListadoClientesService();
    }, [availabilityInterval, manualDate]);

    const obtieneListadoClientesService = async () => {
        const usuarioLocalStorage = sessionStorage.getItem('usuarioApp');
        if (!!usuarioLocalStorage) {
            const usuarioLocalStorageObj = JSON.parse(usuarioLocalStorage);
            const body = {
                idCompany: usuarioLocalStorageObj.idCompany
            };
            const response = await requestPost(body, 15);
            if (!response.error) {
                const { estado, objeto } = response.data;
                if (estado) {
                    setClientes(objeto);
                }
            }
        }
    };

    const obtieneAgendaDelDiaService = async () => {
        if (!!profesionalSeleccionado) {
            const body = {
                fechaAsignada: formatDate(manualDate),
                idUsuario: profesionalSeleccionado.id,
                intervaloAgenda: availabilityInterval
            };
            const response = await requestPost(body, 8);
            if (!response.error) {
                const { estado, objeto } = response.data;
                if (estado) {
                    setHorariosDisponibilidad(objeto);
                } else {
                    setModalError(true);
                }
            } else {
                setModalError(true);
            }
        }
    };

    const confirmaCargueCitaService = async () => {
        if (!!profesionalSeleccionado) {
            const body = {
                noDocumento,
                nombres,
                apellidos,
                correo,
                telefono,
                observaciones,
                fechaAsignada: formatDate(manualDate),
                horaAsignada: manualTime,
                idUsuario: profesionalSeleccionado.id,
                intervaloAgendamiento: availabilityInterval
            };
            const response = await requestPost(body, 10);
            if (!response.error) {
                const { estado, mensaje } = response.data;
                if (estado) {
                    setModalSuccess(true);
                    setformStateValue({
                        noDocumento: '',
                        nombres: '',
                        apellidos: '',
                        correo: '',
                        correoConfirma: '',
                        telefono: '',
                        observaciones: ''
                    });
                    setManualTime('');
                    obtieneAgendaDelDiaService();
                    setExecuteConsulta(!executeConsulta);
                } else {
                    if (mensaje === 'AT_BCK_004') {
                        setModalOccupied(true);
                    } else {
                        setModalError(true);
                    }
                }
            } else {
                setModalError(true);
            }
        }
    };

    const seleccionaHora = (hora) => {
        setManualTime(hora);
    };

    const activaFlujoAgendate = (page) => {
        switch (page) {
            case 'PAGE_1': setClassAnimateFlujo('carrusel-p1'); break;
            case 'PAGE_2': setClassAnimateFlujo('carrusel-p2'); break;
            case 'PAGE_3': setClassAnimateFlujo('carrusel-p3'); break;
            default: setClassAnimateFlujo('carrusel-p1');
        }
    };

    const avanzaRegistrarCitaAction = () => {
        setMsgError(false);
        if (manualTime.length > 0) {
            activaFlujoAgendate('PAGE_2');
        } else {
            setMsgError(true);
        }
    };

    const avanzaFormularioClienteAction = () => {
        let formValidado = [];
        setformState({
            noDocumentoRef: false,
            nombresRef: false,
            apellidosRef: false,
            correoRef: false,
            correoConfirmaRef: false,
            telefonoRef: false,
        });

        if (noDocumento.length === 0) formValidado.push('noDocumentoRef');
        if (nombres.length === 0) formValidado.push('nombresRef');
        if (apellidos.length === 0) formValidado.push('apellidosRef');
        if (correo.length === 0) {
            formValidado.push('correoRef');
        } else if (correo !== correoConfirma) {
            formValidado.push('correoRef');
            formValidado.push('correoConfirmaRef');
        }
        if (correoConfirma.length === 0) formValidado.push('correoConfirmaRef');
        if (telefono.length === 0) formValidado.push('telefonoRef');

        if (formValidado.length === 0) {
            const clienteEncontrado = clientes.find(c => c.numeroIdentificacion === noDocumento);
            if (!clienteEncontrado) {
                setModalNuevoCliente(true);
            } else {
                activaFlujoAgendate('PAGE_3');
            }
        } else {
            setformState({
                noDocumentoRef: formValidado.includes('noDocumentoRef'),
                nombresRef: formValidado.includes('nombresRef'),
                apellidosRef: formValidado.includes('apellidosRef'),
                correoRef: formValidado.includes('correoRef'),
                correoConfirmaRef: formValidado.includes('correoConfirmaRef'),
                telefonoRef: formValidado.includes('telefonoRef'),
            });
        }
    };

    const changeInput = (e) => {
        const { name, value } = e.target;

        if (name === 'noDocumento') {
            const clienteEncontrado = clientes.find(c => c.numeroIdentificacion === value);
            if (clienteEncontrado) {
                setformStateValue(prev => ({
                    ...prev,
                    noDocumento: value,
                    nombres: clienteEncontrado.nombres || '',
                    apellidos: clienteEncontrado.apellidos || '',
                    correo: clienteEncontrado.correo1 || '',
                    correoConfirma: clienteEncontrado.correo1 || '',
                    telefono: clienteEncontrado.telefono1 || ''
                }));
            } else {
                setformStateValue(prev => ({
                    ...prev,
                    noDocumento: value,
                    nombres: '',
                    apellidos: '',
                    correo: '',
                    correoConfirma: '',
                    telefono: ''
                }));
            }
        } else {
            setformStateValue(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };

    const setIntervaloSeleccionadoAction = (intervalo) => {
        setManualTime('');
        setMsgError(false);
        setAvailabilityInterval(intervalo);
    };

    const setManualDateAction = (date) => {
        setManualTime('');
        setMsgError(false);
        setManualDate(date);
    };

    const handleCloseError = () => setModalError(false);
    const handleCloseSuccess = () => {
        setModalSuccess(false);
        activaFlujoAgendate('PAGE_1');
    };
    const handleCloseOccupied = () => setModalOccupied(false);

    const handleSoloSeguir = () => {
        setModalNuevoCliente(false);
        activaFlujoAgendate('PAGE_3');
    };

    const guardarYSeguirClienteService = async () => {
        setModalNuevoCliente(false);
        const usuarioLocalStorage = sessionStorage.getItem('usuarioApp');
        let idCompany = 0;
        if (!!usuarioLocalStorage) {
            const usuarioLocalStorageObj = JSON.parse(usuarioLocalStorage);
            idCompany = usuarioLocalStorageObj.idCompany;
        }
        const body = {
            tipoDocumento: 'C.C',
            numeroDocumento: noDocumento,
            nombres: nombres,
            apellidos: apellidos,
            direccion: '',
            correo: correo,
            correo2: '',
            telefono1: telefono,
            telefono2: '',
            idCompany: idCompany
        };
        await requestPost(body, 2);
        obtieneListadoClientesService();
        activaFlujoAgendate('PAGE_3');
    };

    return (
        <>
            <div className="div-carrusel-info-agenda-container">
                <div className={`div-carrusel-track ${classAnimateFlujo}`}>
                    {/* PAGE 1: Calendar & Slots */}
                    <div className='div-carrusel-agenda'>
                        <div className='div-carrusel-info-agenda'>
                            <h4 className="mb-3">Registrar cita:</h4>
                            <div className="my-3">
                                <p className='p-label-form'>Selecciona la <span className='p-bold'>fecha</span>, elige el <span className='p-bold'>intervalo de horas disponible</span> y define la <span className='p-bold'> hora de la cita</span>.</p>
                            </div>
                            <div className="row m-0">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-5 p-0" >
                                    <div className='div-container-calendar-element-constainer'>
                                        <div className='div-container-calendar-element'>
                                            <div className='div-calendar-element'>
                                                <Calendar onChange={setManualDateAction} value={manualDate} minDate={getColombiaDate()} className='react-calendar' />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-sm-12 col-md-12 col-lg-7 p-0" >
                                    <h2 className='size-db-info-agenda-h2'>Fecha seleccionada: {formatDate(manualDate)}</h2>
                                    <div className="mt-3">
                                        <label className='p-label-form'>Seleccione el intervalo de tiempo:</label>
                                        <select className="form-control" value={availabilityInterval} onChange={(e) => setIntervaloSeleccionadoAction(e.target.value)}>
                                            <option value="60min">Cada 1 hora</option>
                                            <option value="30min">Cada 30 minutos</option>
                                            <option value="20min">Cada 20 minutos</option>
                                        </select>
                                    </div>
                                    <div className="mt-3">
                                        <label className='p-label-form'>Seleccione la hora de la cita:</label>
                                        <div className="row m-0">
                                            {horariosDisponibilidad.map((hora, index) => (
                                                <div key={index} className="col-4 col-sm-3 col-md-3 col-lg-3" >
                                                    <div className='div-header-agenda-disponble'>
                                                        <div className={`div-hora-agendate-disponible ${manualTime === hora.horaAgendaValue ? 'selected-time' : ''} ${hora.horaAgendaActivo ? 'time-disabled' : ''}`}
                                                            onClick={() => !hora.horaAgendaActivo && seleccionaHora(hora.horaAgendaValue)}
                                                            style={{
                                                                backgroundColor: hora.horaAgendaActivo ? '#e9ecef' : (manualTime === hora.horaAgendaValue ? 'orange' : ''),
                                                                cursor: hora.horaAgendaActivo ? 'not-allowed' : 'pointer',
                                                                color: hora.horaAgendaActivo ? '#6c757d' : (manualTime === hora.horaAgendaValue ? 'white' : ''),
                                                                opacity: hora.horaAgendaActivo ? 0.6 : 1
                                                            }}>
                                                            {hora.horaAgendaValue}
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    <div className="div-btbn-agenda-control">
                                        {msgError ? <p className='frt-message-error mt-2'>**Por favor seleccione una hora</p> : <br />}
                                        <div className="my-3">
                                            <button className='btn btn-link a-link-blue' onClick={() => avanzaRegistrarCitaAction()}>
                                                Continuar<FontAwesomeIcon className='ms-2' icon={faArrowRight} />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* PAGE 2: Client Form */}
                    <div className='div-carrusel-agenda' >
                        <div className='div-carrusel-info-agenda'>
                            <div className='div-titulo-info-page-2'>
                                <FontAwesomeIcon className='icons-volver-agenda' icon={faChevronLeft} onClick={() => activaFlujoAgendate('PAGE_1')} />
                                <h1 className='size-landing-h2 titulo-form-page-2'>Datos del cliente:</h1>
                            </div>
                            <div className='div-info-agendate-bloque'>
                                <p className='p-label-form'> No de documento: </p>
                                <input type="text" name='noDocumento' className={noDocumentoRef ? 'form-control form-control-error' : 'form-control'} value={noDocumento} onChange={changeInput} autoComplete='off' />
                                <p className='p-label-form'> Nombres: </p>
                                <input type="text" name='nombres' className={nombresRef ? 'form-control form-control-error' : 'form-control'} value={nombres} onChange={changeInput} autoComplete='off' />
                                <p className='p-label-form'> Apellidos: </p>
                                <input type="text" name='apellidos' className={apellidosRef ? 'form-control form-control-error' : 'form-control'} value={apellidos} onChange={changeInput} autoComplete='off' />
                                <p className='p-label-form'> Correo electrónico: </p>
                                <input type="text" name='correo' className={correoRef ? 'form-control form-control-error' : 'form-control'} value={correo} onChange={changeInput} autoComplete='off' />
                                <p className='p-label-form'> Confirmar correo electrónico: </p>
                                <input type="text" name='correoConfirma' className={correoConfirmaRef ? 'form-control form-control-error' : 'form-control'} value={correoConfirma} onChange={changeInput} autoComplete='off' />
                                <p className='p-label-form'> Número celular: </p>
                                <input type="text" name='telefono' className={telefonoRef ? 'form-control form-control-error' : 'form-control'} value={telefono} onChange={changeInput} autoComplete='off' />
                            </div>
                            <div className="div-btbn-agenda-control">
                                <div className="my-3">
                                    <button className='btn btn-link a-link-blue' onClick={() => avanzaFormularioClienteAction()}>
                                        Continuar<FontAwesomeIcon className='ms-2' icon={faArrowRight} />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* PAGE 3: Confirmation */}
                    <div className='div-carrusel-agenda'>
                        <div className='div-carrusel-info-agenda'>
                            <div className='div-titulo-info-page-2'>
                                <FontAwesomeIcon className='icons-volver-agenda' icon={faChevronLeft} onClick={() => activaFlujoAgendate('PAGE_2')} />
                                <h1 className='size-landing-h2 titulo-form-page-2'>¡Tu cita está casi lista!</h1>
                            </div>
                            <div className='div-info-agendate-bloque'>
                                <div className='div-info-agenda-step-3'>
                                    <p className='p-label-info-text font-size-info-agenda'>{formatDate(manualDate)} </p>
                                    <p className='p-label-info-text font-size-info-agenda'>{manualTime} Hrs.</p>
                                </div>
                                <div className='div-info-item-step-3'><p className='p-label-info-text'>Nombre:</p><p className='p-label-info'>{nombres} {apellidos}</p></div>
                                <div className='div-info-item-step-3'><p className='p-label-info-text'>Correo:</p><p className='p-label-info'>{correo}</p></div>
                                <div className='div-info-item-step-3'><p className='p-label-info-text'>Telefono:</p><p className='p-label-info'>{telefono}</p></div>
                                <div className='mt-3'>
                                    <p className='p-label-info'>Este espacio es para ti: si hay algo que quieras tener en consideración, escríbelo aquí: <span className='text-opcional-mini'>(Opcional)</span></p>
                                    <textarea className='form-control mt-2' name='observaciones' value={observaciones} onChange={changeInput} rows={4} />
                                </div>
                                <div className='div-buttoms-formulario-confirma-cita mt-4'>
                                    <button className='bottom-custom-secondary' onClick={() => confirmaCargueCitaService()}>
                                        <FontAwesomeIcon icon={faCheckDouble} className="me-2" /> Confirmar
                                    </button>
                                </div>
                                <p className='p-label-info my-3 text-center'>Al confirmar, recibirás un correo con los detalles de tu cita.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal isOpen={modalError} toggle={handleCloseError} className='modal-perfil-cliente'>
                <ModalHeader toggle={handleCloseError}>
                    <h4>Error de comunicación <FontAwesomeIcon icon={faExclamationTriangle} className='icon-error' /> </h4>
                </ModalHeader>
                <ModalBody><p>Vaya, tenemos algunas dificultades de comunicación. Por favor intenta más tarde.</p></ModalBody>
                <ModalFooter><Button variant="primary" onClick={handleCloseError}>Aceptar</Button></ModalFooter>
            </Modal>

            <Modal isOpen={modalSuccess} toggle={handleCloseSuccess} className='modal-perfil-cliente'>
                <ModalHeader toggle={handleCloseSuccess}>
                    <h4>Cita Registrada <FontAwesomeIcon icon={faCheckDouble} className='icon-success' style={{ color: 'green' }} /> </h4>
                </ModalHeader>
                <ModalBody><p>¡Excelente! La cita ha sido registrada exitosamente. Hemos enviado un correo con los detalles.</p></ModalBody>
                <ModalFooter><Button variant="primary" onClick={handleCloseSuccess}>Aceptar</Button></ModalFooter>
            </Modal>

            <Modal isOpen={modalOccupied} toggle={handleCloseOccupied} className='modal-perfil-cliente'>
                <ModalHeader toggle={handleCloseOccupied}>
                    <h4>Espacio ocupado <FontAwesomeIcon icon={faExclamationTriangle} className='icon-error' style={{ color: 'orange' }} /> </h4>
                </ModalHeader>
                <ModalBody><p>Lo sentimos, el espacio seleccionado acaba de ser ocupado. Por favor, selecciona un horario diferente.</p></ModalBody>
                <ModalFooter><Button variant="primary" onClick={handleCloseOccupied}>Entendido</Button></ModalFooter>
            </Modal>

            <Modal isOpen={modalNuevoCliente} toggle={handleSoloSeguir} className='modal-perfil-cliente'>
                <ModalHeader toggle={handleSoloSeguir}>
                    <h4><FontAwesomeIcon icon={faUserPlus} className='me-2' style={{ color: 'orange' }} />Cliente nuevo detectado</h4>
                </ModalHeader>
                <ModalBody>
                    <p className='p-label-form'>El documento <strong>{noDocumento}</strong> no está registrado en tu lista de clientes.</p>
                    <p className='p-label-form mt-2'>¿Deseas guardar a <strong>{nombres} {apellidos}</strong> como cliente antes de continuar?</p>
                </ModalBody>
                <ModalFooter>
                    <Button variant="secondary" outline onClick={handleSoloSeguir}>Solo continuar</Button>
                    <Button variant="primary" onClick={guardarYSeguirClienteService}>
                        <FontAwesomeIcon icon={faUserPlus} className='me-1' /> Guardar y continuar
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};